/** PURE_IMPORTS_START ._zip PURE_IMPORTS_END */
import { ZipOperator } from './zip';
export function zipAll(project) {
    return function (source) { return source.lift(new ZipOperator(project)); };
}
//# sourceMappingURL=zipAll.js.map 



//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/rxjs/_esm5/operators/zipAll.js
// module id = ../../../../rxjs/_esm5/operators/zipAll.js
// module chunks = vendor